<template>
    <div>
        <app-card
            headerIcon="biotech"
            heading="Pending QC"
            colClasses=""
            customClasses="mb-0"
            :fullScreen="true"
            :reloadable="true"
            :closeable="true"
            :footer="true"
            :fullBlock="true"
            refreshMethod="refreshQualityControl"
            :reload="reload"
        >
            <qc-inspection></qc-inspection>
            <v-spacer slot="footer"></v-spacer>
            <v-btn slot="footer" class="mr-2" color="primary" @click="$router.push({ name: 'quality_control' })" small>{{ $t("lang.view_all") }}</v-btn>
            <v-btn slot="header" icon small @click="refreshQualityControl"><v-icon>refresh</v-icon></v-btn>
        </app-card>
    </div>
</template>
<script>
import QcInspection from "App_components/Widgets/QcInspection.vue";
import { mapActions, mapState } from "vuex";
export default {
    components: {
        QcInspection,
    },
    props: {
        refreshMethod: {
            type: Function,
        },
    },
    data() {
        return {
            name: "qc_inspection",
            reload: false,
        };
    },
    computed: {
        ...mapActions(["fetchQualityControl"]),
        ...mapState({
            dashboard_quality_control: (state) => state.quality_control.dashboard_quality_control,
        }),
    },
    methods: {
        async refreshQualityControl(refresh = false) {
            this.reload = true;
            if (refresh) {
                await this.$store.commit("commitQualityControl", {
                    property: "dashboard_quality_control",
                    with: null,
                });
            }

            await this.$store.dispatch("fetchQualityControl", {
                url: "quality_control",
                method: "get",
                stateProperty: "dashboard_quality_control",
                dataProperty: "quality_control",
                commit: true,
                body: {
                    status: "pending",
                },
            });
            this.reload = false;
        },
    },
};
</script>
